import confirmationPopupComponent from './confirmationPopup.component';
import popupModule from '../index';

const confirmationPopupModule = angular.module('app.common.ertConfirmationPopup', [popupModule])
	.component('ertConfirmationPopup', confirmationPopupComponent)
	.name;

export default confirmationPopupModule;
